define(function (require) {

    var App = window.App || {};
    var LPQueue = require('web-agent-utils/LPQueue');

    var ResponseQueueManager = function () {
        this.applicationType = "ResponseQueueManager";
        var that = this;
        var participants = {};
        var participantsResponseQueue = new LPQueue();
        var shortcutRegistered = false;

        var modelController = window.App.agentController;

        var lineSources = {
            agent: "agent",
            visitor: "visitor"
        };

        var lineSubTypes = {
            REGULAR: "REGULAR"
        };

        var chatStates = {
            ENDED: "ended",
            TRANSFERRED: "transferred",
            CHATTING: "chatting"
        };

        modelController.bindModelParam("agent.status", handleStatusChanged, that);
        window.App.viewEventsHandler.bindEvent({appName: this.applicationType, UIEvent: window.App.viewEventsHandler.eventType.SHOW_FIRST_IN_QUEUE, callback: showFirstInQueue});

        function showFirstInQueue() {
            var participantToShow = participantsResponseQueue.peek();
            if (participantToShow) {
                window.App.viewEventsHandler.fireEvent({appName: participantToShow, UIEvent: window.App.viewEventsHandler.eventType.VISITOR_FOCUSED});
            }
        }

        function handleStatusChanged(data) {
            if (typeof data.newValue !== 'undefined') {
                if (data.newValue !== 'loggedIn') {
                    for (var key in participants) {
                        if (participants.hasOwnProperty(key)) {
                            var visitorId = participants[key].visitorId;
                            window.App.viewEventsHandler.unbindEvent({appName: visitorId, UIEvent: window.App.viewEventsHandler.eventType.VISITOR_DISPOSED, callback: visitorDisposed});
                            participants[key] = null;
                            delete participants[key];
                        }
                    }
                    participants = {};
                    modelController.unbindModelParam("participants.myEngagements", handleNewParticipant, that);
                    modelController.unbindModelParam("agent.agentName", handleAgentName, that);
                } else {
                    modelController.bindModelParam("participants.myEngagements", handleNewParticipant, that);
                    modelController.bindModelParam("agent.agentName", handleAgentName, that);
                }
            }
        }

        function handleAgentName(data) {
            if (data && data.newValue) {
                this.agentName = data.newValue;
            }
        }

        function handleNewParticipant(data) {
            for (var visitorId in data.newValue) {
                if (data.newValue.hasOwnProperty(visitorId)) {
                    if (lpTag.WebAgent.logicController.isAcceptedEngagement(visitorId)) { // It was decided that we only support this feature for my accepted chats and not for spectated ones.
                        monitorParticipant(visitorId);
                    } else {
                        var participantPath = lpTag.WebAgent.logicController.getParticipantPath(visitorId);
                        modelController.bindModelParam(participantPath + '.participantInfo.acceptedEngagement', addAcceptedEngagement, that); // this is done for the case that it will become my chat due to transfer
                    }
                }
            }
        }

        function addAcceptedEngagement(data) {
            if (!data.newValue) {
                return;
            }
            var visitorId = data.key.split(".")[2];
            monitorParticipant(visitorId);
        }

        function monitorParticipant(visitorId) {
            if (!participants[visitorId]) {
                participants[visitorId] = {visitorId: visitorId};
                var participantPath = lpTag.WebAgent.logicController.getParticipantPath(visitorId);
                modelController.bindModelParam(participantPath + ".chats", handleNewChat, that);
                window.App.viewEventsHandler.bindEvent({appName: visitorId, UIEvent: window.App.viewEventsHandler.eventType.VISITOR_DISPOSED, callback: visitorDisposed});
            }
        }

        function visitorDisposed(e) {
            if (e) {
                var visitorId;
                if (e.newValue && e.newValue.eventData && e.newValue.eventData.visitorId) {
                    visitorId = e.newValue.eventData.visitorId;
                } else {
                    visitorId = e.newValue.appName;
                }
                removeFromParticipantQueue(visitorId);
                var participantPath = lpTag.WebAgent.logicController.getParticipantPath(visitorId);
                modelController.unbindModelParam(participantPath + ".chats", handleNewChat, that);
                modelController.unbindModelParam("chats." + participants[visitorId].chatId + ".newChatLine.lines", handleNewLineAdded, that);
                modelController.unbindModelParam("chats." + participants[visitorId].chatId + ".chatInfo.state", handleChatStateChanged, that);
                modelController.unbindModelParam(participantPath + '.participantInfo.acceptedEngagement', addAcceptedEngagement, that);
                window.App.viewEventsHandler.unbindEvent({appName: visitorId, UIEvent: window.App.viewEventsHandler.eventType.VISITOR_DISPOSED, callback: visitorDisposed});
                participants[visitorId] = null;
                delete participants[visitorId];
            }
        }

        function handleNewChat(data) {
            for (var chatId in data.newValue) {
                if (data.newValue.hasOwnProperty(chatId)) {
                    monitorChat(chatId);
                }
            }
        }

        function monitorChat(chatId) {
            var visitorId = modelController.getModelParam("chats." + chatId + ".visitorInfo.visitorId");
            participants[visitorId].chatId = chatId;
            modelController.bindModelParam("chats." + chatId + ".newChatLine.lines", handleNewLineAdded, that);
            modelController.bindModelParam("chats." + chatId + ".chatInfo.state", handleChatStateChanged, that);
        }

        function handleNewLineAdded(data) {
            var chatId = data.key.split(".")[1];
            var visitorId = modelController.getModelParam("chats." + chatId + ".visitorInfo.visitorId");
            visitorId = visitorId ? visitorId.toString() : null;
            if (!visitorId) {
                return;
            }
            var lastLine = data.newValue[data.newValue.length - 1];
            switch (lastLine.source) {
                case lineSources.agent :
                    if (lastLine.by) {
                        if (lastLine.by === this.agentName) {
                            if (lastLine.subType) {
                                if (lastLine.subType === lineSubTypes.REGULAR) {
                                    removeFromParticipantQueue(visitorId);
                                }
                            }
                            else {     //TODO: after appserver is 17 - remove this else and combine conditions
                                removeFromParticipantQueue(visitorId);
                            }
                        } else {
                            addToParticipantsQueue(visitorId);
                        }
                    }
                    break;
                case lineSources.visitor :
                    addToParticipantsQueue(visitorId);
                    break;
                default :
                    break;
            }
        }

        function handleChatStateChanged(data) {
            var chatId = data.key.split(".")[1];
            var visitorId = modelController.getModelParam("chats." + chatId + ".visitorInfo.visitorId");
            visitorId = visitorId ? visitorId.toString() : null;
            if (visitorId && participantsResponseQueue.contains(visitorId)) {
                if (data.newValue === chatStates.ENDED || data.newValue === chatStates.TRANSFERRED) {
                    removeFromParticipantQueue(visitorId);
                    modelController.unbindModelParam("chats." + chatId + ".newChatLine.lines", handleNewLineAdded, that);
                    modelController.unbindModelParam("chats." + chatId + ".chatInfo.state", handleChatStateChanged, that);
                }
            }
        }

        function addToParticipantsQueue(visitorId) {
            if (!participantsResponseQueue.contains(visitorId)) {
                participantsResponseQueue.enqueue(visitorId);
            }
            if (window.App.agentShortcutsManager && !shortcutRegistered && !lpTag.WebAgent.logicController.hasMessagingFeature()) {
                shortcutRegistered = true;
                window.App.viewEventsHandler.fireEvent({
                    appName: that.applicationType,
                    UIEvent: window.App.viewEventsHandler.eventType.NEXT_TO_TAKE_ACTION_REGISTER,
                    eventData: true
                });
            }
        }

        function removeFromParticipantQueue(visitorId) {
            if (participantsResponseQueue.contains(visitorId)) {
                participantsResponseQueue.removeFromQueue(visitorId);
            }
            if (window.App.agentShortcutsManager && shortcutRegistered && participantsResponseQueue.isEmpty()) {
                shortcutRegistered = false;
                window.App.viewEventsHandler.fireEvent({
                    appName: that.applicationType,
                    UIEvent: window.App.viewEventsHandler.eventType.NEXT_TO_TAKE_ACTION_UNREGISTER,
                    eventData: false
                });
            }
        }
    };

    return ResponseQueueManager;

});
